import FileUploadComponent from './file-upload.component'

export default FileUploadComponent
